import { render, staticRenderFns } from "./ExerciseModal.vue?vue&type=template&id=49843ce4"
import script from "./ExerciseModal.vue?vue&type=script&lang=js"
export * from "./ExerciseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports